export default {
  newDesign: true,
  parameters: {
    landing_id: "TrQPr",
    segment: 11,
  },
  title: "ÇOCUĞUNUZUN GELECEKTEKİ BAŞARISI BURADA BAŞLIYOR | Kodland",
  downtimeUrl: "https://www.kodland.org/tr",
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz!",
    subtitle:
      "Maalesef, tablet veya telefonlar derslerimizi kullanmak için uygun değildir. Bir sonraki derslerimizde sizi görmekten mutluluk duyacağız!",
  },
  quizRotateBySteps: {
    1: {
      type: "age-start",
      title: "Çocuğunuz kaç yaşında?",
      image: {
        url: "/welcome/turkey_profit_desk.png",
      },
      imageMobile: {
        url: "/welcome/turkey_profit_mob.png",
      },
    },
    2: {
      question: "Programlama öğrenirken sizi en çok ne çekiyor?",
      answers: [
        "🚀 Gelecekte yüksek gelir elde etme fırsatı",
        "💰 İlk parasını kazanma imkânı",
        "🧠 Mantık ve disiplin geliştirme",
        "✅ Yukarıdakilerin hepsi",
      ],
    },
    3: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/latam_profit.png",
      subtitle:
        "«18 yaşından önce programlamaya başlayan gençlerin, başarılı bir teknoloji kariyeri kurma ve gelecekte daha yüksek gelir elde etme olasılığı iki kat daha fazladır»<br><br><i>Kaynak: MIT Araştırması, Early STEM Education</i>",
      button: "Harika!",
    },
    4: {
      question: "Çocuğunuzun başlıca ilgi alanları nelerdir?",
      answers: [
        "🎨 Yaratıcılık ve sanat",
        "🎮 Video oyunları ve gaming",
        "🐾 Hayvanlar ve doğa",
        "⚽ Spor ve fiziksel aktiviteler",
        "📚 Okuma ve yeni şeyler öğrenme",
        "🔬 Bilim ve teknoloji",
      ],
    },
    5: {
      question:
        "Çocuğunuzun online dersler için kullanabileceği bir masaüstü veya dizüstü bilgisayarı var mı?",
      answers: [
        "💻 Evet",
        {
          answer: "😕 Hayır",
          stopAnswer: true,
        },
      ],
    },
    6: {
      title: "Tebrikler! 🎉",
      typeInfo: "congrats",
      subtitle:
        "Kaydı tamamlamak için '📆 Ders rezervasyonu yap' butonuna tıklayın",
      button: "📆 Ders rezervasyonu yap",
    },
    7: {
      title: "Ücretsiz ders rezervasyonu yapın",
      type: "one-page-contacts",
      subtitle: "",
      button: "Neredeyse bitti 🔥",
    },
    8: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    9: {
      title: "Kaydı tamamlamak için bu bilgileri inceleyin ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Ders için çalışan bir bilgisayara veya dizüstü bilgisayara ihtiyacınız olacağını ve ders boyunca çocuğunuza eşlik etmeniz gerektiğini lütfen unutmayın. Dersin bireysel ve kişiselleştirilmiş olduğunu hatırlatırız.",
      button: "Sırada ne var?",
    },
    10: {
      title:
        "Deneme dersinizden önce e-postanızı ve WhatsApp'ınızı kontrol edin 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Dersinizden 24 saat önce bir hatırlatma göndereceğiz ve 2 saat öncesinde katılımınızı onaylamanızı isteyeceğiz. İletişim kurmamız, dersinizin planlandığı gibi gerçekleşmesi için önemlidir.",
      button: "Başka neler var?",
    },
    11: {
      title: "Ders platformumuzda gerçekleşecek 💻",
      typeInfo: "classroom",
      subtitle:
        "WhatsApp ve e-posta yoluyla bir bağlantı ve özel bir kod alacaksınız. Sadece bağlantıya tıklayın, doğrudan derse yönlendirileceksiniz. Ekstra uygulama veya indirme gerekmiyor.",
      button: "Anladım ✅",
    },
  },
};
